import { render, staticRenderFns } from "./Nfces.vue?vue&type=template&id=4a227980&"
import script from "./Nfces.vue?vue&type=script&lang=js&"
export * from "./Nfces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports